import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useState } from 'react';
import Hint from '../components/Hint/Hint';
import InfoBox from '../components/InfoBox/InfoBox';
import { useMenu } from "../contexts/MenuContext";
import withForm from '../layouts/withForm';
const ImportExport = ({handleChange}) => {

    const {
        settingData, 
        setReload
    } = useMenu();  
    // const [settings, setSettings] = useState({});
    const [importData, setImportData] = useState('');

    const [processingImport, setProcessingImport] = useState(false)
    const [processingImportRing, setProcessingImportRing] = useState(false)
    const [processingImportTick, setProcessingImportTick] = useState(false)

    const [processingExport, setProcessingExport] = useState(false)
    const [processingExportRing, setProcessingExportRing] = useState(false)
    const [processingExportTick, setProcessingExportTick] = useState(false)

    const handleExport = () => {
        const blob = new Blob([JSON.stringify(settingData, null, 2)], {
            type: 'application/json',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'ultimate-security-settings.json';
        link.click();
    };    

    // Read file content and put it in hidden textarea
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const content = event.target.result;
                JSON.parse(content); // Validate JSON
                setImportData(content);
            } catch (err) {
                alert('Invalid JSON file.');
            }
        };
        reader.readAsText(file);
    };

    // Submit imported JSON
    const handleImport = async () => {
        setProcessingExport(true);
        setProcessingExportRing(true);
        try {
            const parsed = JSON.parse(importData);
            const response = await apiFetch({
                path: '/ultimate-security/v1/settings',
                method: 'POST',
                data: parsed,
            });

            if (response.success) {
                // alert('Settings imported successfully!');
                setProcessingExportRing(false);
                setProcessingExportTick(true);
                
                setTimeout(()=> {
                    setProcessingExportTick(false)
                    setProcessingExport(false)
                    setReload(Math.random()); // Trigger reload
                },1000)

                
            } else {
                alert('Import failed.');
            }
        } catch (e) {
            alert('Invalid JSON content.');
        }
    }; 
    return (
        <>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Backup Settings", "ultimate-security")}</h5>
                            {/* <p className="pl-body text-text">{__("Export your current settings", "ultimate-security")}</p> */}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Export your current settings.", "ultimate-security")}/>
                                    <button 
                                        type="button" 
                                        className="button button-link" 
                                        onClick={handleExport}
                                        disabled={processingImport}
                                    >
                                        {
                                            processingImport ? __( "Processing...", "ultimate-security" ) : __( "Download .json", "ultimate-security" )
                                        }
                                    </button>
                                    {processingImportRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {processingImportTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                </div>
                                
                                <div className="content-below-with-hint mt-2">                                    
                                    <InfoBox className="small-infobox" title={__( "Note", "ultimate-security" )} content={__( "Generate a downloadable file.", "ultimate-security" )} />
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Restore Settings", "ultimate-security")}</h5>
                            {/* <p className="pl-body text-text">{__("Copy and paste here", "ultimate-security")}</p> */}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-12">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Import your previous exported settings.", "ultimate-security")}/>
                                    <div>
                                        <input
                                            type="file"
                                            accept="application/json"
                                            onChange={handleFileChange}
                                        />
                                        <div className="d-flex align-items-center">                                            
                                            <button 
                                                type="button" 
                                                className="button button-link" 
                                                onClick={handleImport} 
                                                disabled={!importData}
                                            >
                                                {
                                                    processingExport ? __( "Processing...", "ultimate-security" ) : __( "Import Settings", "ultimate-security" )
                                                }
                                            </button>
                                            {processingExportRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                            {processingExportTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}

                                        </div>

                                        {/* Hidden textarea with the JSON content */}
                                        <textarea
                                            style={{ display: 'none' }}
                                            value={importData}
                                            readOnly
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(ImportExport);